import React from 'react';
import { HeroTitle, HeroText, Grid, Row, Col } from '@cof/gravity-react';
import parse from 'html-react-parser';

import { agentFormStrings } from '../../strings';

import './AgentForm.scss';

const AgentForm = ({ activeLanguage }) => (
  <div className="agent-form">
    <Grid>
      <Row>
        <Col lg={12}>
          <HeroTitle>{agentFormStrings[activeLanguage].DeprecationTitle}</HeroTitle>
          <HeroText>
            {parse(agentFormStrings[activeLanguage].DeprecationMessage)}
          </HeroText>
        </Col>
      </Row>
    </Grid>
  </div>
);

export default AgentForm;
